import { Card, CardContent } from "../../../Components/StakingRisk/ui/card";
import { cn } from "../../../StakingRisk/lib/utils";

export default function StatsCard({ title, value, icon: Icon, trend, trendValue, bgColor = "bg-blue-500" }) {
  return (
    <Card className="overflow-hidden border-none shadow-sm">
      <CardContent className="p-0">
        <div className="flex items-stretch">
          <div className={cn("flex items-center justify-center px-4 py-6", bgColor)}>
            <Icon className="h-6 w-6 text-white" strokeWidth={1.5} />
          </div>
          <div className="flex-1 p-4">
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">{title}</h3>
            <div className="mt-1 flex items-baseline justify-between">
              <div className="flex flex-col">
                <span className="text-2xl font-semibold text-gray-900 dark:text-white">
                  {value}
                </span>
                {trend && (
                  <span className={cn(
                    "text-xs font-medium mt-1",
                    trend === "up" ? "text-green-600" : "text-red-600"
                  )}>
                    {trend === "up" ? "↑" : "↓"} {trendValue}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}